export const AUTH_HIDE_VERIFICATION_MODAL = 'AUTH_HIDE_VERIFICATION_MODAL'
export const AUTH_SHOW_VERIFICATION_MODAL = 'AUTH_SHOW_VERIFICATION_MODAL'
export const CLEAR_VERIFICATION_QUEUE = 'CLEAR_VERIFICATION_QUEUE'
export const PUSH_POST_VERIFICATION_QUEUE_ITEM =
  'PUSH_POST_VERIFICATION_QUEUE_ITEM'
